var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 6H3.86667C2.83574 6 2 6.76751 2 7.71429V16.2857C2 17.2325 2.83574 18 3.86667 18H14.1333C15.1643 18 16 17.2325 16 16.2857V7.71429C16 6.76751 15.1643 6 14.1333 6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.99963L20.553 7.72363C20.7054 7.64747 20.8748 7.61151 21.045 7.61918C21.2152 7.62684 21.3806 7.67788 21.5256 7.76744C21.6706 7.85699 21.7902 7.98211 21.8733 8.1309C21.9563 8.2797 21.9999 8.44724 22 8.61763V15.3816C21.9999 15.552 21.9563 15.7196 21.8733 15.8684C21.7902 16.0172 21.6706 16.1423 21.5256 16.2318C21.3806 16.3214 21.2152 16.3724 21.045 16.3801C20.8748 16.3878 20.7054 16.3518 20.553 16.2756L16 13.9996V9.99963Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.1d45dff34de6cef2dac7bec26fa46e1d.svg";
export { ForwardRef as ReactComponent };